module.exports = __webpack_public_path__ + "img/bezlimit.c3cbf12a.png";